import * as React from 'react';
import { Popover2 } from '@blueprintjs/popover2';
import { Button } from '@blueprintjs/core';
import { useSelector, useDispatch } from 'react-redux';
import { JobUuid } from '@biolibtech/biolib-js';
import { deviceDetect } from 'react-device-detect';
import { useSendInquiryMutation } from '../../../../../apiHooks/inquiryApi';
import { IRootState } from '../../../../../state/rootReducer';
import notificationActions from '../../../../../state/notification/notificationActions';
import { stringifyLogMessages } from '../../../utils';

interface IProps {
    jobId: JobUuid;
}

export default function ReportErrorButton(props: IProps) {
    const { jobId } = props;
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const [hasReportedSuccessfully, setHasReportedSuccessfully] = React.useState(false);
    const [sendInquiry, { isLoading }] = useSendInquiryMutation();
    const dispatch = useDispatch();

    const jobWrapper = useSelector((state: IRootState) => state.appRun.jobWrapperDict[jobId]);

    const onSendErrorReport = async () => {
        setIsPopoverOpen(false);

        const { logMessages, error, app } = jobWrapper;
        const jobLog = stringifyLogMessages(logMessages);
        const errorMessage = error === null ? 'NULL' : error.stack ? error.stack : error.toString();

        const message = `[bl-error-report]

${location.origin}/${app.account_handle}/${app.name}/

${JSON.stringify(deviceDetect(undefined))}

____BEGIN_STACK_TRACE____

${errorMessage}

____END_STACK_TRACE____

____BEGIN_APPLICATION_LOG____

${jobLog}

____END_APPLICATION_LOG____`.replaceAll(location.origin, 'biolib_stack_base_url');

        try {
            await sendInquiry({ message }).unwrap();
            setHasReportedSuccessfully(true);
        } catch (error) {
            dispatch(notificationActions.addError(`Failed to send error report\n${error.toString()}`));
        }
    };

    if (hasReportedSuccessfully) {
        return (<Button rightIcon='tick' intent='success' disabled={true}>Error Reported</Button>);
    }

    return (
        <Popover2
            className='float-right'
            isOpen={isPopoverOpen}
            onClose={() => setIsPopoverOpen(false)}
            content={
                <div className='p-4'>
                    <Button fill={true} intent='primary' large={true} onClick={onSendErrorReport}>
                        Send Error Report
                    </Button>
                    <hr/>
                    <p className='text-gray-500'>
                        The error report will contain the <br/>
                        stacktrace and application log.
                    </p>
                </div>
            }>
            <Button rightIcon='error' intent='primary' loading={isLoading} onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                Report Error
            </Button>
        </Popover2>
    );
}
